import React, { Component } from "react";
import { connect } from "react-redux";
import { ADR_REVIEW } from "../../../_constants/actionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdrClarificationCommentRowV3 from "./AdrClarificationCommentRowV3";

class AdrClarificationCommentsV3 extends Component {
  componentDidMount() {
    this.addBlankIfEmpty();
  }

  componentDidUpdate(prevProps, prevState) {
    this.addBlankIfEmpty();
  }

  addBlankIfEmpty = () => {
    const { clarificationComments, addBlank, user } = this.props;
    if (
      !clarificationComments ||
      !Array.isArray(clarificationComments) ||
      clarificationComments.length === 0
    )
      addBlank(user);
  };

  handleClick_add = (e) => {
    const { addBlank, user, markAdrDirty } = this.props;
    e.preventDefault();
    markAdrDirty();
    addBlank(user);
  };

  render() {
    const { tabId, projectId, clarificationComments, userIsReviewer, markAdrDirty } =
      this.props;
    return (
      <div className="card mx-2 mb-2">
        <div className="card-body bg-lightyellow">
          <h3>RE/SR Comments</h3>
          {userIsReviewer &&
            "These approval/clarification comments will be incorporated into the accepted DR."}
          <hr className="mb-2 mt-2" />
          {clarificationComments.map((cc, index) => (
            <AdrClarificationCommentRowV3
              key={`clarComRowKey_${cc.clientId}`}
              tabId={tabId}
              projectId={projectId}
              comment={cc}
              userIsReviewer={userIsReviewer}
              markAdrDirty={markAdrDirty}
            />
          ))}
          <hr className="mb-2 my-2" />
          <div className="form-row">
            <div className="col">
              <button
                className="btn btn-secondary"
                id="addClarCom"
                onClick={this.handleClick_add}
                disabled={!userIsReviewer}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-1" />
                Add Comment
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user || null,
  clarificationComments: state.adr.openAdrs[ownProps.tabId]
    ? state.adr.openAdrs[ownProps.tabId].clarificationComments || []
    : null,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addBlank: (user) => {
    if (user)
      dispatch({
        type: ADR_REVIEW.CLARIFICATION_COMMENTS.ADD_BLANK,
        tabId: ownProps.tabId,
        byUserId: user.userId,
      });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdrClarificationCommentsV3);
